import React from 'react'
import {useCustomPreference} from '../../hooks/use-custom-preference'
import {Helmet} from 'react-helmet'
import {useLocation} from 'react-router-dom'

const Digioh = () => {
    const digiohVendorID = useCustomPreference('digiohVendorID')
    const location = useLocation()

    return (
        <>
            {digiohVendorID && (
                <Helmet>
                    <script
                        async
                        type="text/javascript"
                        src={`https://www.lightboxcdn.com/vendor/${digiohVendorID}/lightbox_inline.js?v=${location.pathname}`}
                        data-testid="digioh-script"
                    ></script>
                </Helmet>
            )}
        </>
    )
}

export default Digioh
